import { render } from "./FeladatList.vue?vue&type=template&id=3b9c3102&scoped=true"
import script from "./FeladatList.vue?vue&type=script&lang=js"
export * from "./FeladatList.vue?vue&type=script&lang=js"

import "./FeladatList.vue?vue&type=style&index=0&id=3b9c3102&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9c3102"]])

export default __exports__